// import React, { useEffect, useState } from "react";
// import Navbar from "../../layouts/Navbar";
// import Sidebar from "../../layouts/Sidebar";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const Salary = () => {
//   const navigate = useNavigate();
//   const api = process.env.REACT_APP_API;
//   const apikey = process.env.REACT_APP_KEY;
//   const [salary,setSalary]=useState({})
//   const [paymentHistory,setPaymentHistory] =useState([])
// //   // Dummy data
// //   const balance = 26013.0;
//   const paid = 8112.0;
//   const paidCount = 15;
//   const unpaid = 550.0;
//   const unpaidCount = 3;

// const userid=localStorage.getItem('userid')

//   const fetchSalary = async () => {
//       try {
//         const response = await axios.get(`${api}/salary/viewsalarydata/${userid}`, {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             apikey: apikey,
//           },
//         });
//         console.log("Salary data:", response.data.data[0]);
//         setSalary(response.data.data[0])
//       } catch (error) {
//         console.error("Error fetching salary data:", error);
//       }
//     };


//   const paymentrecord=  async()=>{
//     console.log(userid)
//     try{
//     const response = await axios.get (`${api}/salary/paymentrecords/${userid}`,{
//       headers:{
//          apikey: apikey,
//       }
//     })
//     console.log("payRecord ",response.data)
//     setPaymentHistory(response.data.data)
//     }
//     catch(error){
//       console.log(error)

//     }
//   }
// useEffect(() => {
  

//     fetchSalary();
//     paymentrecord();
//   }, []); 


//   const handleQrClick = () => {
//     navigate("/salary-qr");
//   };

//   return (
//     <div className="container-scroller">
//       <Navbar />
//       <div className="container-fluid page-body-wrapper d-flex">
//         <Sidebar />
//         <div
//           className="main-panel flex-grow-1"
//           style={{
//             padding: "2rem",
//             fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//             backgroundColor: "#f8f9fa",
//             minHeight: "100vh",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               marginBottom: "1.5rem",
//             }}
//           >


            
//             <div style={{ fontSize: "1.25rem", fontWeight: "600" }}>
//               Balance <span style={{ marginLeft: "0.3rem", cursor: "pointer" }}>👁️</span>
//               <div style={{ fontSize: "2rem", fontWeight: "700", marginTop: "0.3rem" }}>
//                 ₹{(salary?.salarybalance || 0).toLocaleString()}
//               </div>
//             </div>
//              <div style={{gap:'10px'}}>
//                   <button
//               onClick={() => navigate("/addsalaryqr")}
//               style={{
//                 backgroundColor: "#306ef7",
//                 color: "white",
//                 border: "none",
//                 borderRadius: "20px",
//                 padding: "0.5rem 1.5rem",
//                 fontWeight: "600",
//                 cursor: "pointer",
//                 marginRight:"10px"
            
//               }}
//             >
//               + Salary QR
//             </button>
//                 <button
//               onClick={() => navigate("")}
//               style={{
//                 backgroundColor: "#306ef7",
//                 color: "white",
//                 border: "none",
//                 borderRadius: "20px",
//                 padding: "0.5rem 1.5rem",
//                 fontWeight: "600",
//                 cursor: "pointer",
//               }}
//             >
//              👁️ Salary QR
//             </button>
//              </div>
//           </div>

//           {/* Paid and Unpaid Cards */}
//           <div style={{ display: "flex", gap: "1rem", marginBottom: "2rem" }}>
//             <div
//               style={{
//                 flex: 1,
//                 backgroundColor: "#e6f4ea",
//                 borderRadius: "12px",
//                 padding: "1rem",
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
//                 cursor: "pointer",
//               }}
//             >
//               <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.5rem" }}>
//                 <div style={{ fontWeight: "700", color: "#32a852" }}>Paid</div>
//                 {/* <div>{paidCount}</div> */}
//               </div>
//               {/* <div style={{ fontWeight: "700", fontSize: "1.5rem" }}>₹{paid.toLocaleString()}</div> */}
//             </div>
//             <div
//               style={{
//                 flex: 1,
//                 backgroundColor: "#fff3cd",
//                 borderRadius: "12px",
//                 padding: "1rem",
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
//                 cursor: "pointer",
//               }}
//             >
//               <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.5rem" }}>
//                 <div style={{ fontWeight: "700", color: "#d39e00" }}>Unpaid</div>
//                 {/* <div>{unpaidCount}</div> */}
//               </div>
//               {/* <div style={{ fontWeight: "700", fontSize: "1.5rem" }}>₹{unpaid.toLocaleString()}</div> */}
//             </div>
//           </div>

//           {/* Recent Payments */}
//           <h2 style={{ fontWeight: "700", marginBottom: "1rem" }}>Recent Payment</h2>

//           <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
//             {paymentHistory.map((pay, i) => (
//               <div
//                 key={i}
//                 style={{
//                   backgroundColor: "white",
//                   borderRadius: "12px",
//                   padding: "1rem",
//                   boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                   display: "flex",
//                   alignItems: "center",
//                   cursor: "pointer",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                 
//                   <div>
//                     <div style={{ fontWeight: "700", fontSize: "1.1rem" }}>{pay.paymenttype}</div>
//                     <div style={{ color: "gray" }}>{pay.mop}</div>
//                   </div>
//                 </div>

//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "2rem",
//                     fontSize: "0.9rem",
//                     color: "#555",
//                     minWidth: "320px",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <div>
//                     <div style={{ fontWeight: "600", color: "#888" }}>PAY PERIOD</div>
//                     <div>{new Date(pay.date).toISOString().split("T")[0]}</div>

//                   </div>
//                   <div>
//                     <div style={{ fontWeight: "600", color: "#888" }}>TOTAL HOUR</div>
//                     <div>{pay.time} hrs</div>
//                   </div>
//                     <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                 
//                    <img
//                     src={`${api}/uploads/transactionproof/${pay.proof}`}
//                     alt={pay.userid}
//                     style={{ width: "50px", height: "50px", borderRadius: "50%" }}
//                   />
//                 </div>
//                   <div>
//                     <div style={{ fontWeight: "600", color: "#888" }}>PAID TOTAL</div>
//                     <div style={{ fontWeight: "700" }}>${pay.amount.toLocaleString()}</div>
//                   </div>

//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Salary QR Button */}
    
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Salary;





import React, { useEffect, useState } from "react";
import Navbar from "../../layouts/Navbar";
import Sidebar from "../../layouts/Sidebar";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BsX } from "react-icons/bs";   // ✅ ADDED
import "./Salary.css";

const Salary = () => {
  const navigate = useNavigate();
  const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_KEY;

  const [salary, setSalary] = useState({});
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const [popupVisible, setPopupVisible] = useState(false);
  const [popupImage, setPopupImage] = useState(null);

  const [myqr, setMyqr] = useState(null);

  // Modal states (You FORGOT these)
  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [payPopup, setPayPopup] = useState(false);

  const userid = localStorage.getItem("userid");

  // Fetch salary balance
  const fetchSalary = async () => {
    try {
      const response = await axios.get(`${api}/salary/viewsalarydata/${userid}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          apikey,
        },
      });
      setSalary(response.data.data[0]);
    } catch (error) {
      console.error("Error fetching salary data:", error);
    }
  };

  // Fetch my QR code
  const handleViewQr = async () => {
    try {
      const response = await axios.get(`${api}/salary/myqr/${userid}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          apikey,
        },
      });

      const qr = response.data.data.salaryqr;
      setMyqr(`${api}/uploads/salaryqr/${qr}`);
      openPayModal(); // OPEN MODAL
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch payment history
  const paymentrecord = async () => {
    try {
      const response = await axios.get(`${api}/salary/paymentrecords/${userid}`, {
        headers: { apikey },
      });

      const sortedData = response.data.data.sort((a, b) => b.id - a.id);
      setPaymentHistory(sortedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSalary();
    paymentrecord();
  }, []);

  const openImagePopup = (imgSrc) => {
    setPopupImage(imgSrc);
    setPopupVisible(true);
  };

  const closeImagePopup = () => {
    setPopupVisible(false);
    setPopupImage(null);
  };

  // ---------- MODAL OPEN ----------
  const openPayModal = () => {
    setPayPopup(true);
    setVisible(true);

    setTimeout(() => {
      setAnimate(true);
    }, 10);
  };

  // ---------- MODAL CLOSE ----------
  const closePayModal = () => {
    setAnimate(false);
    setTimeout(() => {
      setVisible(false);
      setPayPopup(false);
      setMyqr(null);
    }, 300);
  };

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper d-flex">
        <Sidebar />

        <div
          className="main-panel flex-grow-1"
          style={{
            padding: "2rem",
            fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
            minHeight: "100vh",
          }}
        >
          {/* Balance Section */}
          <div className="salary_balance-section">
            <div className="salary_balance">
              Balance <span className="salary_eye">👁️</span>
              <div className="salary_balance-amount">
                ₹{(salary?.salarybalance || 0).toLocaleString()}
              </div>
            </div>

            <div className="salary_button-group">
              <button
                className="salary_btn salary_btn-primary"
                onClick={() => navigate("/addsalaryqr")}
              >
                + Salary QR
              </button>

              <button
                className="salary_btn salary_btn-primary"
                onClick={handleViewQr}
              >
                👁️ Salary QR
              </button>
            </div>
          </div>

          {/* Paid / Unpaid Cards */}
          <div className="salary_status-cards">
            <div className="salary_card salary_card-paid">
              <div className="salary_card-title">Paid</div>
            </div>
            <div className="salary_card salary_card-unpaid">
              <div className="salary_card-title">Unpaid</div>
            </div>
          </div>

          {/* Recent Payments */}
          <div className="salary_recent-header">
            <h2>Recent Payment</h2>
            {paymentHistory.length > 4 && (
              <p
                className="salary_seeall"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? "See Less" : "See All"}
              </p>
            )}
          </div>

          <div className="salary_payment-list">
            {(showAll ? paymentHistory : paymentHistory.slice(0, 4)).map(
              (pay, i) => (
                <div className="salary_payment-card" key={i}>
                  <div className="salary_payment-info">
                    <div className="salary_payment-type">{pay.paymenttype}</div>
                    <div className="salary_payment-mop">{pay.mop}</div>
                  </div>

                  <div className="salary_payment-details">
                    <div>
                      <div className="salary_label">PAY PERIOD</div>
                      <div>{new Date(pay.date).toISOString().split("T")[0]}</div>
                    </div>

                    <div>
                      <div className="salary_label">TOTAL HOUR</div>
                      <div>{pay.time} hrs</div>
                    </div>

                    <div className="salary_img-wrapper">
                      <img
                        src={`${api}/uploads/transactionproof/${pay.proof}`}
                        alt="proof"
                        className="salary_img"
                        onClick={() =>
                          openImagePopup(
                            `${api}/uploads/transactionproof/${pay.proof}`
                          )
                        }
                      />
                    </div>

                    <div>
                      <div className="salary_label">PAID TOTAL</div>
                      <div className="salary_amount">
                        ₹{pay.amount.toLocaleString()}
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>

          {/* PAYMENT PROOF POPUP */}
          {popupVisible && (
            <div className="salary_popup" onClick={closeImagePopup}>
              <img
                src={popupImage}
                alt="Payment Proof"
                className="salary_popup-img"
                onClick={(e) => e.stopPropagation()}
              />
              <span className="salary_popup-close" onClick={closeImagePopup}>
                &times;
              </span>
            </div>
          )}

          {/* QR MODAL POPUP */}
          {visible && myqr && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: animate ? "rgba(0,0,0,0.5)" : "rgba(0,0,0,0)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10000,
                transition: "background 0.5s ease",
              }}
            >
              <div
                style={{
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  width: "400px",
                  maxWidth: "90%",
                  transform: animate ? "translateY(0)" : "translateY(200%)",
                  transition: "transform 0.5s ease",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
                }}
                className="hide-scrollbar"
              >
                {/* CLOSE BUTTON */}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <BsX
                    style={{
                      cursor: "pointer",
                      fontSize: "25px",
                      border: "1px solid red",
                      color: "red",
                      borderRadius: "50%",
                    }}
                    onClick={closePayModal}
                  />
                </div>

                {/* QR VIEW */}
                <div className="form-group">
                  <label>Employee QR</label>
                  <img
                    src={myqr}
                    alt="Employee QR"
                    style={{
                      width: "100%",
                      height: "300px",
                      marginTop: "10px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Salary;
